export default {
    mounted(el) {
      const input = el.querySelector('input');
  
      if (!input) return;
  
      input.addEventListener('input', (e) => {
        let value = e.target.value?.replace(/\D/g, '') || ''; // 안전하게 처리
        if (value.length > 11) value = value.slice(0, 11);
  
        let formatted = value;
        if (value.length <= 3) {
          formatted = value;
        } else if (value.length <= 7) {
          formatted = `${value.slice(0, 3)}-${value.slice(3)}`;
        } else {
          formatted = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7)}`;
        }
  
        e.target.value = formatted;
        input.dispatchEvent(new Event('input')); // v-model 동기화
      });
    },
  };
  